import { render } from "./DostavkaPage.vue?vue&type=template&id=2c63b859&scoped=true"
const script = {}

import "./DostavkaPage.vue?vue&type=style&index=0&id=2c63b859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c63b859"]])

export default __exports__